// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3eVhc","vLegacy":"SelectSecondary_vLegacy__1kajv","error":"SelectSecondary_error__3efpu","disabled":"SelectSecondary_disabled__3L82J"};